import { api } from '../apiClient'
import type { ProjectData } from '../apiTypes'

// 프로젝트 관련 API
export const projectsAPI = {
  getAllProjects: () => api.get('/api/projects'),
  getProject: (projectId: string) => api.get(`/api/projects/${projectId}`),
  createProject: (project: ProjectData) => api.post('/api/projects', project),
  updateProject: (projectId: string, project: Partial<ProjectData>) =>
    api.put(`/api/projects/${projectId}`, project),
  deleteProject: (projectId: string) =>
    api.delete(`/api/projects/${projectId}`),
  getMyRole: (projectId: string) =>
    api.get(`/api/projects/${projectId}/my-role`),
  getCapabilities: (projectId: string) =>
    api.get(`/api/projects/${projectId}/capabilities`),
  getPermissions: (projectId: string) =>
    api.get(`/api/projects/${projectId}/permissions`),
  getMembers: (projectId: string) => api.get(`/api/projects/${projectId}`),
  addMember: (
    projectId: string,
    data: { email: string; role: string; addedBy: string }
  ) => api.post(`/api/projects/${projectId}/members`, data),
  removeMember: (projectId: string, memberEmail: string) =>
    api.delete(`/api/projects/${projectId}/members/${memberEmail}`),
  updateMemberRole: (projectId: string, memberEmail: string, newRole: string) =>
    api.put(
      `/api/projects/${projectId}/members/${memberEmail}/role?new_role=${newRole}`
    ),
}

// 글로벌 관리자 관리 API
export const globalAdminsAPI = {
  me: () => api.get('/api/global-admins/me'),
  list: (token?: string) =>
    api.get('/api/global-admins/', {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }),
  add: (email: string, token?: string) =>
    api.post('/api/global-admins/', null, {
      params: { email },
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }),
  remove: (email: string, token?: string) =>
    api.delete(`/api/global-admins/${encodeURIComponent(email)}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }),
}

export const systemAPI = {
  healthCheck: () => api.get('/health'),
  getSystemInfo: () => api.get('/api/system/info'),
}
